import React from "react";
import { ArrowRight, Mail, ShieldCheck, CheckCircle2, Sparkles } from "lucide-react";
import { heroTruckImage } from "../mock/mock";
import { useLightbox } from "../context/LightboxContext";

export default function Hero() {
  const { openLightbox } = useLightbox();
  return (
    <section className="relative overflow-hidden border-b border-white/[0.06]">
      <div className="absolute inset-0 grid-bg" />
      <div className="absolute inset-0 radial-fade" />
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-transparent to-[#0a0a0b]" />

      <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-24 lg:py-28 grid lg:grid-cols-[1.15fr_1fr] gap-10 lg:gap-14 items-center">
        <div className="fade-in">
          <div className="inline-flex items-center gap-2 chip px-3 py-1.5 rounded-full text-[11.5px] tracking-wide text-[#c8c5bc]">
            <span className="pulse-dot" />
            Magic Valley Owned &amp; Trusted Business
          </div>

          <h1 className="font-display font-extrabold text-[36px] sm:text-[52px] lg:text-[68px] leading-[1.05] lg:leading-[1.02] tracking-[-0.03em] mt-6 text-[#f4efe6]">
            Reliable Material Delivery &amp;{" "}
            <span className="text-[#f4efe6]">Dump Truck Services</span>
          </h1>

          <p className="mt-5 md:mt-6 text-[15px] md:text-[16.5px] leading-relaxed text-[#b6b3ab] max-w-xl">
            Equipped to handle residential and commercial projects of all sizes
            in the Magic Valley area. Honest work, dependable service, and
            getting the job done right.
          </p>

          <div className="mt-7 grid grid-cols-3 gap-2 md:gap-3 max-w-2xl">
            {[
              { icon: CheckCircle2, label: "Honest Pricing" },
              { icon: ShieldCheck, label: "Dependable Service" },
              { icon: Sparkles, label: "Done Right" },
            ].map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="chip rounded-md px-2.5 md:px-3 py-2 md:py-2.5 flex items-center gap-1.5 md:gap-2"
              >
                <Icon size={14} className="text-[#c9b98a] shrink-0" />
                <span className="text-[11px] md:text-[12.5px] text-[#c8c5bc] font-medium">
                  {label}
                </span>
              </div>
            ))}
          </div>

          <div className="mt-7 md:mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#contact"
              className="btn-primary inline-flex items-center gap-2 px-5 py-3.5 rounded-md text-[13.5px] font-semibold"
            >
              <Mail size={16} />
              Request Free Quote
            </a>
            <a
              href="#gallery"
              className="btn-ghost inline-flex items-center gap-2 px-5 py-3.5 rounded-md text-[13.5px] font-semibold"
            >
              View Materials
              <ArrowRight size={16} />
            </a>
          </div>
        </div>

        {/* Right visual */}
        <div className="relative fade-in">
          <div
            role="button"
            tabIndex={0}
            onClick={() =>
              openLightbox([
                {
                  image: heroTruckImage,
                  title: "Ortiz Heavy Truck Hauling",
                  caption: "Reliable material delivery across Magic Valley",
                },
              ])
            }
            className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl aspect-[4/3] max-w-[560px] mx-auto cursor-pointer group"
          >
            <img
              src={heroTruckImage}
              alt="Ortiz Heavy Truck Hauling"
              className="photo-crisp w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 img-overlay" />
            <div className="absolute bottom-4 right-4 flex items-center gap-2 chip rounded-lg px-3 py-2 bg-[#0a0a0b]/70 backdrop-blur">
              <ShieldCheck size={16} className="text-[#c9b98a]" />
              <div className="leading-tight">
                <div className="text-[9.5px] tracking-[0.2em] text-[#8a877f] font-medium">
                  MAGIC VALLEY
                </div>
                <div className="text-[12.5px] text-[#f4efe6] font-semibold">
                  100% Guaranteed
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
